<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统监控</el-breadcrumb-item>
      <el-breadcrumb-item>系统日志</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-form :inline="true">
        <el-form-item label="日期">
          <el-date-picker
            v-model="value"
            type="daterange"
            align="left"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            unlink-panels
            :editable="false"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input v-model="keyword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList">查询</el-button>
          <el-button @click="exportExcel">导出日志</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表区域 -->
      <el-table
        ref="multipleTable"
        :data="dataList"
        stripe
        border
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
      >
        <el-table-column
          :resizable="false"
          type="index"
          label="序号"
          width="55"
        ></el-table-column>
        <el-table-column prop="userName" label="操作人"></el-table-column>
        <el-table-column
          prop="userId"
          label="用户ID"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ip"
          label="IP"
          sortable="custom"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column
          prop="location"
          label="IP所在地"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column prop="time" label="耗时" sortable="custom">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.time > 5000" type="danger"
              >{{ scope.row.time }}ms</el-tag
            >
            <el-tag v-else-if="scope.row.time > 2000" type="warning"
              >{{ scope.row.time }}ms</el-tag
            >
            <el-tag v-else type="success">{{ scope.row.time }}ms</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="url"
          label="访问URL"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="className"
          label="类名"
          sortable="custom"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="method"
          label="方法"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="operation"
          label="操作类型"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="reqTime"
          label="请求时间"
          sortable="custom"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="respTime"
          label="响应时间"
          sortable="custom"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="userAgent"
          label="客户端"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="params"
          label="参数"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import Collapse from '@/components/collapse/Collapse'
import CollapseItem from '@/components/collapse/CollapseItem'
export default {
  components: {
    Collapse,
    CollapseItem,
  },
  data() {
    return {
      // 获取列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
        // 状态
        status: [],
      },

      // 列表
      dataList: [],
      total: 0,

      //checkbox选择的值
      multipleSelection: [],

      //日期
      value: '',

      //关键词
      keyword: '',

      //快捷选择日期
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },

  methods: {
    //导出excel
    exportExcel() {
      this.getDataList()
      let res = this.$export('log/exportExcel', this.queryInfoparams, 'log')
    },

    // 获取 查询用户数据列表
    getDataList() {
      this.getQueryParams()
      console.log(this.queryInfoparams.params)
      // 分页查询用户
      this.$post('log/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          console.log(res)
          this.dataList = res.records
          this.total = res.total
        }
      )
    },
    //获取查询参数
    getQueryParams() {

      if (this.value != null && this.value.length != 0) {
        this.queryInfoparams.params = {
          startReqTime: this.value[0],
          endReqTime: this.value[1],
          keyword: this.keyword,
        }
      } else {
        this.queryInfoparams.params = { keyword: this.keyword }
      }
    },
    //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order
      this.getDataList()
    },
    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
  },
  mounted() {
    this.getDataList()
  },
}
</script>

<style lang='less' scoped>
</style>